export default __webpack_public_path__ + "static/media/shopping-cart.33ce5d15.svg";